import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = 'https://yrykbsvsokisdgvmoruz.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InlyeWtic3Zzb2tpc2Rndm1vcnV6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODY3MTE1NzYsImV4cCI6MjEwMjI4NzU3Nn0.Pzky34OIU8i5dFrPpeJBGcf-M2X4TktYAgfct8tcE5U'

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  throw new Error('Missing Supabase variables');
}

export default createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
})